module.exports = __webpack_public_path__ + "static/img/20180414165947.5f9fc473.jpg";